export const TYPES_LANGUAGES = { CA: 'ca', ES: 'es' }
